import * as React from 'react';
import { getNextAvailableDate } from '../../AvailabilityCalendar/utils.js';

const useNextAvailableDate = (date, calendarAvailability, skip = false)=>{
    return React.useMemo(()=>{
        if (skip) {
            return undefined;
        }
        return getNextAvailableDate(date, calendarAvailability.data);
    }, [
        skip,
        date,
        calendarAvailability
    ]);
};

export { useNextAvailableDate as default, useNextAvailableDate };
//# sourceMappingURL=use-next-available-date.js.map
